import { Injectable } from '@angular/core';
/** Default dropdown configuration */
export class BsDropdownConfig {
    constructor() {
        /** default dropdown auto closing behavior */
        this.autoClose = true;
    }
}
BsDropdownConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
BsDropdownConfig.ctorParameters = () => [];
//# sourceMappingURL=bs-dropdown.config.js.map